module.exports = __webpack_public_path__ + "static/media/campaign2.2536550e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/campaign2.png
// module id = 2227
// module chunks = 0